import { EmptyControl, HvlQueryModel, MaxLength, MinLength } from '@hvlng/framework-bff/core';

import { JsonObject, JsonProperty } from 'json2typescript';
import { HvlDateConverter } from '@hvlng/framework-bff/util';

@JsonObject('KovanHrPerPersonnelQueryModel')
export class PerPersonnelQueryModel extends HvlQueryModel {
    @EmptyControl()
    @JsonProperty('peopleNum', Number, true)
    peopleNum: number = null;

    @EmptyControl()
    @JsonProperty('perPeopleStatusId', Number, true)
    perPeopleStatusId: number = null;

    @MaxLength(50)
    @MinLength(2)
    @JsonProperty('name', String, true)
    name: string = null;

    @MaxLength(50)
    @MinLength(2)
    @JsonProperty('surname', String, true)
    surname: string = null;

    @MaxLength(50)
    @MinLength(2)
    @JsonProperty('fatherName', String, true)
    fatherName: string = null;

    @EmptyControl()
    @JsonProperty('identitySerialNumber', String, true)
    identitySerialNumber: string = null;

    @EmptyControl()
    @JsonProperty('employeeTypeUuid', String, true)
    employeeTypeUuid: string = null;

    @EmptyControl()
    @JsonProperty('employeeTypeUuidList', [String], true)
    employeeTypeUuidList: Array<string> = new Array<string>();

    @EmptyControl()
    @JsonProperty('employeeSubtypeUuid', String, true)
    employeeSubtypeUuid: string = null;

    @EmptyControl()
    @JsonProperty('workAreaUuid', String, true)
    workAreaUuid: string = null;

    @EmptyControl()
    @JsonProperty('workSubareaUuid', String, true)
    workSubareaUuid: string = null;

    @EmptyControl()
    @JsonProperty('identificationNumber', String, true)
    identificationNumber: string = null;

    @EmptyControl()
    @JsonProperty('titleId', Number, true)
    titleId: number = null;

    @EmptyControl()
    @JsonProperty('cadreId', Number, true)
    cadreId: number = null;

    @EmptyControl()
    @JsonProperty('positionId', Number, true)
    positionId: number = null;

    @EmptyControl()
    @JsonProperty('orgDefinitionId', Number, true)
    orgDefinitionId: number = null;

    @EmptyControl()
    @JsonProperty('perPeopleUuidList', [String], true)
    perPeopleUuidList?: Array<string> = new Array<string>();

    @JsonProperty('personId', Number, true)
    personId: number = null;

    @EmptyControl()
    @JsonProperty('personnelId', Number, true)
    personnelId: number = null;

    @EmptyControl()
    @JsonProperty('registryNumber', [String], true)
    registryNumber?: Array<string> = new Array<string>();

    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    active: boolean = true;

    @EmptyControl()
    @JsonProperty('onlySubEmployee', Boolean, true)
    onlySubEmployee: boolean = null;

    @EmptyControl()
    @JsonProperty('onlyManagers', Boolean, true)
    onlyManagers: boolean = null;

    @EmptyControl()
    @JsonProperty('startDate', HvlDateConverter, true)
    startDate: Date = null;

    @EmptyControl()
    @JsonProperty('authorizationRoleTypeCodeList', [String], true)
    authorizationRoleTypeCodeList: Array<string> = new Array<string>();

    @EmptyControl()
    @JsonProperty('maxLevel', Number, true)
    maxLevel: number = null;

    @EmptyControl()
    @JsonProperty('managerialPositionOwners', Boolean, true)
    managerialPositionOwners: boolean = null;

    @EmptyControl()
    @JsonProperty('childOrgUnitId', Number, true)
    childOrgUnitId: number = null;


    @EmptyControl()
    @JsonProperty('formerEmployees', Boolean, true)
    formerEmployees: boolean = null;

    @EmptyControl()
    @JsonProperty('authorityCodeSet', [String], true)
    authorityCodeSet: Array<string> = new Array<string>();


    @EmptyControl()
    @JsonProperty('date', HvlDateConverter, true)
    date: Date = null;

    @EmptyControl()
    @JsonProperty('isEmployee', Boolean, true)
    isEmployee: boolean = null;
    @EmptyControl()
    @JsonProperty('recendToHitap', Boolean, true)
    recendToHitap: boolean = null;

    @EmptyControl()
    @JsonProperty('matchModeStartsWith', Boolean, true)
    matchModeStartsWith: boolean = null;

    @EmptyControl()
    @JsonProperty('personnelMovementType', String, true)
    personnelMovementType: string = null;

    @EmptyControl()
    @JsonProperty('minServiceClassOrderLevel', Number, true)
    minServiceClassOrderLevel: number = null;
    @EmptyControl()
    @JsonProperty('matchModeIgnoreCaseSensitive', Boolean, true)
    matchModeIgnoreCaseSensitive: boolean = null;


    constructor(managerialPositionOwners: boolean = null) {
        super();
        this.managerialPositionOwners = managerialPositionOwners;
    }
}
